import type { Filters } from '@/context/useFilters/types';
import { orderObjectKeys } from '@/utils/orderObjectKeys';

import { compactFilterRecord } from './compactFilters';

export function resetPersistedFilterOptions(filters: Filters = {}): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem('filters', JSON.stringify(orderObjectKeys(compactFilterRecord(filters))));
  } catch {
    console.warn('Error resetting local storage filters');
  }
}
